import React, { Component } from 'react'
import CarouselCategories from './carousel_categories'

export default class TestCarousel extends Component {
    render() {
        return (
            <div className='container'>
                <CarouselCategories history={this.props.history} />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/test_carousel.js